<template>
  <div id="login-div">
    <div>
      <!--Suspense>-->
      <!--template #default>

            </template>-->
      <p v-if="userIsLoggedIn">Welcome user...</p>
      <button v-else type="button" @click="loginWithGoogle">Login with google</button>

      <!--fallback loading state of suspense #fallback slot-->
      <!--template #fallback>
                Loading...
            </template>
        </Suspense>-->
    </div>
  </div>
</template>

<script setup lang="ts">
//The loginview will be sent the token/code back from google after logging in
//Update the user store and display the greeting
import { ref } from 'vue'
//import { oauthSignIn } from '@/libs/google_auth.js';
import { useUserStore } from '@/stores'
const users = useUserStore()

//run the google login, this view will receive the token/code back
async function loginWithGoogle() {
  console.log('loginWithGoogle button clicked....')
  //await googleSignin();
  //await oauthSignIn();
  await users.signInWithGoogle()
}

const userIsLoggedIn = ref(false)
</script>

<style lang="css" scoped>
.login-div {
  width: 100%;
  height: 100%;
  display: block;
  /* display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;*/
}

button {
  width: 20rem;
  height: 6rem;
  font-size: 2rem;
}
</style>
